// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"6a9f9113","293":"de3feb19","518":"9a54965a","531":"cde6e025","560":"c3665273","638":"e654f57b","777":"c58aff2c","834":"9453af88","996":"23081f53"}[chunkId] + ".chunk.js";
};